<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="clickQuery"
              type="search"
              :placeholder="$l('form_label_search') || '输入关键字快速搜索...'"
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="visible = !visible"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="clickQuery">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="printTag('print')"
              v-if="allow('P')"
            >
              <b-icon-tag></b-icon-tag>
              {{ $l('INDEX.btn_print_tag') || '标签打印' }}
            </b-button>
            <b-button
              class="ml-2"
              size="sm"
              variant="outline-success"
              @click="turnover()"
              v-if="allow('MS')"
            >
              {{ $l('INDEX.form_label_salesman_adjustment') || '业务人员调整' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="visible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item>
              <el-radio-group v-model="form.quantityStatus" size="small">
                <el-radio label="A">{{
                  $l('label_search_all') || '全部'
                }}</el-radio>
                <el-radio label="Y">{{
                  $l('label_search_valid') || '有库存'
                }}</el-radio>
                <el-radio label="N">{{
                  $l('label_search_invalid') || '无库存'
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_fabric_no') || '面料编号'">
              <el-input
                style="width: 100%"
                clearable
                size="small"
                v-model="form.fabricNo"
                :placeholder="$l('table_label_fabric_no') || '面料编号'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('search_label_quantity') || '库存数量'">
                <el-col :span="11">
                  <el-input
                    style="width: 100%"
                    clearable
                    size="small"
                    v-model="form.stockQuantityStart"
                    :placeholder="$l('search_label_quantity_start') || '至少'"
                  ></el-input>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input
                    style="width: 100%"
                    clearable
                    size="small"
                    v-model="form.stockQuantityEnd"
                    :placeholder="$l('search_label_quantity_end') || '至多'"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_fabric_color_name') || '面料颜色'"
            >
              <el-input
                style="width: 100%"
                clearable
                size="small"
                v-model="form.fabricColorTitle"
                :placeholder="$l('form_label_fabric_color_name') || '面料颜色'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_biz_user') || '业务员'"
              prop="fabricAgentCode"
            >
              <dict-select
                v-model="form.fabricAgentCode"
                url="/digitalCenter/common/dict/baseUser"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                :multiple="false"
                clearable
                :options="{ label: 'label', value: 'code' }"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_supplier') || '供应商'"
              prop="supCode"
            >
              <dict-select
                clearable
                filterable
                style="width: 100%"
                size="small"
                v-model="form.supCode"
                url="/digitalCenter/common/dict/masterSupplierDict"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_factory_number') || '工厂面料编号'"
              prop="factoryNumber"
            >
              <el-input
                v-model="form.factoryNumber"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="50"
                clearable
                size="small"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_fabric_name') || '面料'"
              prop="fabricDescriptionArray"
              ><el-select
                v-model="form.fabricDescriptionArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in fabricDescriptionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_flowerType') || '花型'"
              prop="patternArray"
            >
              <el-select
                v-model="form.patternArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in patternOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12"
            ><el-form-item
              :label="$l('form_label_technology') || '工艺'"
              prop="techniqueArray"
            >
              <el-select
                v-model="form.techniqueArray"
                multiple
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in techniqueOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_materialNotes') || '材料备注'"
              prop="constructionArray"
            >
              <el-select
                v-model="form.constructionArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in constructionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_function') || '功能'"
              prop="functionArray"
            >
              <el-select
                v-model="form.functionArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in functionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_fabric_width') || '有效门幅'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.widStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.widEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item prop="widUnit">
                    <dict-select
                      v-model="form.widUnit"
                      url="/digitalCenter/common/dict/biz"
                      :body="{ dictType: 'widUnit' }"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="small"
                      style="width: 100%"
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('search_label_modify_date') || '更新日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_fabricWeight') || '面料克重'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.fabricWeightStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.fabricWeightEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      v-model="form.fabricWeightUnit"
                      url="/digitalCenter/common/dict/biz"
                      :body="{ dictType: 'fabricWeightUnit' }"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="small"
                      style="width: 100%"
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fabricContent') || '面料成分'">
              <el-input
                v-model.trim="form.fabricContent"
                :placeholder="
                  $l('tips_input_fabricContent_placeholder') ||
                  '请输入面料成分...'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消查询</el-button>
        <el-button size="small" type="warning" @click="onReset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="clickQuery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      dialogVisible: false,
      form: {
        searchKey: '',
        fabricNo: '',
        fabricName: '',
        stockQuantityStart: '',
        stockQuantityEnd: '',
        modifyDateStart: '',
        modifyDateEnd: '',
        quantityStatus: 'A',
        functionArray: [], //功能
        constructionArray: [], //材料备注
        fabricDescriptionArray: [], //面料名称
        patternArray: [], //花型
        techniqueArray: [], //工艺
      },
      functionOptions: [], //功能
      constructionOptions: [], //材料备注
      fabricDescriptionOptions: [], //面料名称
      patternOptions: [], //花型
      techniqueOptions: [], //工艺
    }
  },
  mounted() {
    this.onReset()
  },
  activated() {
    this.query()
  },
  methods: {
    fromLoad(type) {
      this.$emit('add', type)
    },
    assign(form) {
      this.form = { ...this.form, ...form }
    },
    clickQuery() {
      this.$emit('reset')
      this.query()
    },
    closeDialog() {
      this.visible = false
    },
    query() {
      this.$emit('submit', this.form)
      this.visible = false
    },
    onReset() {
      this.form = {
        searchKey: '',
        fabricNo: '',
        fabricName: '',
        stockQuantityStart: '',
        stockQuantityEnd: '',
        modifyDateStart: '',
        modifyDateEnd: '',
        quantityStatus: 'A',
      }
      this.$emit('reset')
      this.query()
      this.loadCategoryData()
    },
    loadCategoryData() {
      //功能
      this.$api
        .masterFabricAttributes_attributesSelect({
          fabricAttrTypeEn: 'Function',
        })
        .then((res) => {
          this.functionOptions = res.body.data
        })
        .catch(() => {})
      //材料备注
      this.$api
        .masterFabricAttributes_attributesSelect({
          fabricAttrTypeEn: 'Construction',
        })
        .then((res) => {
          this.constructionOptions = res.body.data
        })
        .catch(() => {})
      //面料名称
      this.$api
        .masterFabricAttributes_attributesSelect({
          fabricAttrTypeEn: 'Fabric Description',
        })
        .then((res) => {
          this.fabricDescriptionOptions = res.body.data
        })
        .catch(() => {})
      //花型
      this.$api
        .masterFabricAttributes_attributesSelect({
          fabricAttrTypeEn: 'Pattern',
        })
        .then((res) => {
          this.patternOptions = res.body.data
        })
        .catch(() => {})
      //工艺
      this.$api
        .masterFabricAttributes_attributesSelect({
          fabricAttrTypeEn: 'Technique',
        })
        .then((res) => {
          this.techniqueOptions = res.body.data
        })
        .catch(() => {})
    },
    printTag() {
      this.$emit('printTag')
    },
    //业务人员调整
    turnover() {
      this.$emit('turnover')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
